export default __webpack_public_path__ + "static/media/hourglass.928d221f.svg";